/**
 * Support Command Center — static copy for `/dashboard/support`.
 * Ticket data is loaded from TreydoraEdBackend (`/api/support/*`).
 */

import { dashboardAsset } from "../utils/dashboardAssets";

/** Same Oshar city spires hero art as Quests (`questDashboardMockData`). */
export const SUPPORT_DASHBOARD_HERO_IMAGE = dashboardAsset("01_hero_oshar_city_spires.png");

/**
 * Optional community Discord — set `REACT_APP_TREYDORA_DISCORD_INVITE_URL` in `.env`.
 * If unset, the Support page shows copy-only guidance (no hardcoded invite in bundle).
 */
export const TREYDORA_DISCORD_INVITE_URL = String(
  process.env.REACT_APP_TREYDORA_DISCORD_INVITE_URL || ""
).trim();

export const SUPPORT_TICKET_CATEGORIES = [
  "Account / Login",
  "Purchase / Stripe",
  "Wallet / MetaMask Sync",
  "Genesis Comic NFT",
  "VR Real Estate NFT",
  "My Library / Reader Access",
  "Marketplace / My Storefront",
  "Bug Report",
  "Partnership / Business Inquiry",
  "Other",
];

export const SUPPORT_PRIORITIES = ["Normal", "High", "Urgent"];

export const SUPPORT_FAST_HELP = [
  {
    key: "wallet",
    title: "Wallet Not Syncing",
    body: "Confirm the same wallet you used at checkout, switch to the correct network in MetaMask, then retry sync from your Gateway or Library vault panels.",
  },
  {
    key: "library",
    title: "Missing Library Item",
    body: "Stripe webhooks can take a minute. Refresh My Library; if an edition still does not appear, note your checkout email and order reference in a ticket.",
  },
  {
    key: "storefront",
    title: "Storefront Locked",
    body: "Seller tools remain in preview. Purchases and storefront publishing still route through official channels — open a ticket with your store slug if something looks wrong.",
  },
  {
    key: "payment",
    title: "Payment Completed But Access Missing",
    body: "Include approximate purchase time and the wallet or email on the receipt. Do not paste full card numbers — last four digits only if needed.",
  },
];
